export default "__VITE_PUBLIC_ASSET__6cb9b354__"